export enum PermitRequestStatus {
    EXPIRED = 'EXPIRED',
    APPLIED = 'APPLIED',
    ACTIVE = 'ACTIVE',
    CANCEL = 'CANCEL',
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    DENIED = 'DENIED',
}

export enum ExpirationPeriodType {
    Annual = 'ANNUAL',
    SpecificDate = 'SPRECIFIC DATE',
    NonExpiring = 'NON-EXPIRING',
    Monthly = 'MONTHLY',
    Daily = 'DAILY',
    Quarterly = 'QUARTERLY',
    MonthStart = 'MONTH START'
}

export enum PermitMode {
    PermitApply = 'permitApply',
    PermitCreate = 'permitCreate',
    PermitFind = 'permitFind'
}
